'use strict';

document.addEventListener('DOMContentLoaded', () => {

  const topSlider = document.getElementById('js-kv__slider');
  const bottomSlider = document.getElementById('js-bottom__slider');

  // Flickity init
  if(topSlider !== null){
    const flck = new Flickity(topSlider, {
      autoPlay: 3000,
      pauseAutoPlayOnHover: false,
      wrapAround: true,
      draggable: false,
      cellAlign: 'left',
      contain: true,
      arrowShape: {
        x0: 30,
        x1: 55, y1: 25,
        x2: 60, y2: 20,
        x3: 40
      },
    });
  }

  if(winWidth <= breakPointMedium && bottomSlider !== null){
    var flckBottom = new Flickity(bottomSlider, {
      autoPlay: 3000,
      pauseAutoPlayOnHover: false,
      wrapAround: true,
      draggable: false,
      cellAlign: 'left',
      contain: true,
      prevNextButtons: false,
      groupCells: 2,
      arrowShape: {
        x0: 30,
        x1: 55, y1: 25,
        x2: 60, y2: 20,
        x3: 40
      },
    });
  }

  window.addEventListener('resize', () => {
    if(resizeTimer !== false){
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(function(){
      if(winWidth === window.innerWidth){
        return;
      }
      location.reload();
    }, 1000);
  });

});
